<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});

const { t } = useTexts();
const route = useRoute('error-code');

const errorCode = computed(() => {
  return route.params.code;
});

const errorTitle = computed(() => {
  if (errorCode.value === 'country') {
    return t('error.general.sorry');
  }

  return errorCode.value;
});

const errorSubtitle = computed(() => {
  if (errorCode.value === 'country') {
    return t('error.general.country');
  }

  return t('error.general.something_wrong');
});
</script>

<template>
  <BaseErrorMessage
    image-type="error"
    :language-switcher="true"
    :message="$t('error.maintenance.message')"
    :subtitle="errorSubtitle"
    :title="errorTitle"
  >
    <BaseCommonLogo
      always-logo
      class="mt-0 flex justify-center"
    />
  </BaseErrorMessage>
</template>
